module.exports = __webpack_public_path__ + "media/frontend/svg/artists1-1079171bb19ca024b6639cfe208b77b4.svg";